export default [{
  path: '/dashboard-tasks',
  name: 'dashboard-tasks',
  component: () => import('./DashboardTasks'),
  meta: {
    resource: 'dashboard-tasks',
    actions: ['read']
  }
}]
